import type { ChangeEvent } from 'react';

export function makeOnChangeHandler<T = string>({
  anyTarget,
  multiple,
  singleTarget,
  multipleTarget,
  conversion,
}: {
  anyTarget?: (id: T | T[]) => void;
  multiple?: boolean;
  singleTarget?: (id: T) => void;
  multipleTarget?: (ids: T[]) => void;
  conversion?: (value: string) => T;
}) {
  if (!(anyTarget || singleTarget || multipleTarget)) {
    return undefined;
  }

  return (e: ChangeEvent<HTMLSelectElement>) => {
    const raw = e.target.value;

    let value: T | T[];
    if (multiple) {
      const keys = raw.split(',').filter((item) => Boolean(item.trim()));
      value = conversion ? keys.map(conversion) : (keys as T[]);
      multipleTarget?.(value);
    } else {
      value = conversion ? conversion(raw) : (raw as T);
      singleTarget?.(value);
    }

    anyTarget?.(value);
  };
}
